export default __webpack_public_path__ + "static/User3-7d2de5be5a7680bb5870f142edb53d99.png";